// This file contains the color used on pages without theming

enum DefaultThemeVariables {
  Background = 'background',
  PrimaryColor = 'primary-color',
  SecondaryColor = 'secondary-color',
  ActiveColor = 'active-color',
  TextPrimaryColor = 'text-primary-color',
  ButtonPrimaryColor = 'button-primary-color',
  ButtonSecondaryColor = 'button-secondary-color',
  BorderRadius = 'border-radius',
  LogoWidth = 'logo-width',
}

export const defaultThemeValues: Record<DefaultThemeVariables, string> = {
  [DefaultThemeVariables.Background]: '#0E0F2D',
  [DefaultThemeVariables.PrimaryColor]: '#47477a',
  [DefaultThemeVariables.SecondaryColor]: '#33326d',
  [DefaultThemeVariables.ActiveColor]: '#5a5ed5',
  [DefaultThemeVariables.TextPrimaryColor]: '#f4f4f4',
  [DefaultThemeVariables.ButtonPrimaryColor]: '#5a5ed5',
  [DefaultThemeVariables.ButtonSecondaryColor]: '#2e305a',
  [DefaultThemeVariables.BorderRadius]: '6px',
  [DefaultThemeVariables.LogoWidth]: '140px',
};
